import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { AuthGuard } from '../../../services/guarad/auth.guard'
import { PendingChangesGuard } from '../../../services/guarad/pending-changes.guard'
import { ClientDetailComponent } from './client-detail.component'
import { LayoutAppClientDetailComponent } from '../layout-app-client-detail/layout-app-client-detail.component'
import { ProfileComponent } from './profile/profile.component'
import { AuditComponent } from './audit/audit.component'
import { MailHistoryComponent } from './mail-history/mail-history.component'
import { ComplianceComponent } from './compliance/compliance.component'
import { DeviceComponent } from './device/device.component'
import { TimelineComponent } from './timeline/timeline.component'
import { CommunicationComponent } from './communication/communication.component'
import { AlignerComponent } from './aligner/aligner.component'
import { ReloadComponent } from './reload/reload.component'
import { AvailabilityGuard } from '../../../services/guarad/availability.guard'
import { ReceiptComponent } from './receipt/receipt.component';

const routes: Routes = [
    {
        path: 'app/main/client/edit/:id',
        canActivate: [AuthGuard, AvailabilityGuard],
        component: LayoutAppClientDetailComponent,
        // path: 'app/main/client/edit/test', canActivate: [AuthGuard], component: ClientDetailComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full', canDeactivate: [PendingChangesGuard] },
            { path: 'home', component: ClientDetailComponent, canDeactivate: [PendingChangesGuard] },
            // {path: 'home/refresh', redirectTo: 'home', pathMatch: 'full', canDeactivate: [PendingChangesGuard]},
            { path: 'profile', component: ProfileComponent, canDeactivate: [PendingChangesGuard] },
            // {path: 'profile/refresh', redirectTo: 'profile', pathMatch: 'full', canDeactivate: [PendingChangesGuard]},
            { path: 'mail', component: MailHistoryComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'audit', component: AuditComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'compliance', component: ComplianceComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'device', component: DeviceComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'timeline', component: TimelineComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'communication', component: CommunicationComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'aligner', component: AlignerComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'receipt', component: ReceiptComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'reload/:url', component: ReloadComponent, canDeactivate: [PendingChangesGuard] },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class ClientDetailRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/client-detail.routing.ts